export default {
	id: 'SIMPLE_PREMIUM_6M_91_14',
	providers: {
		stripe: '',
		braintree: '',
		paltaMap: {
			USD: 'simple_premium_6m_91_14_usd',
			ARS: 'simple_premium_6m_103900_ars',
			AUD: 'simple_premium_6m_139_99_aud',
			BRL: 'simple_premium_6m_519_brl',
			CAD: 'simple_premium_6m_119_99_cad',
			CLP: 'simple_premium_6m_85900_clp',
			COP: 'simple_premium_6m_377900_cop',
			DKK: 'simple_premium_6m_599_dkk',
			EUR: 'simple_premium_6m_91_14_eur',
			GBP: 'simple_premium_6m_91_14_gbp',
			MXN: 'simple_premium_6m_1749_mxn',
			NOK: 'simple_premium_6m_919_nok',
			PLN: 'simple_premium_6m_339_pln',
			SEK: 'simple_premium_6m_869_sek',
			TRY: 'simple_premium_6m_3900_try',
		},
		primer: 'prd_8yJHdIM6yMR6',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 6,
		intro_period_type: 'month',
		next_period_value: 6,
		next_period_type: 'month',
	},
	trial: null,
	subscription: {
		interval: 'month',
		intervalCount: 6,
		priceMap: {
			USD: 91.14,
			ARS: 103900,
			AUD: 139.99,
			BRL: 519,
			CAD: 119.99,
			CLP: 85900,
			COP: 377900,
			DKK: 599,
			EUR: 91.14,
			GBP: 91.14,
			MXN: 1749,
			NOK: 919,
			PLN: 339,
			SEK: 869,
			TRY: 3900,
		},
	},
	options: ($t) => ({
		barChartTooltip: $t('activity_upgrade.6mo.bar_chart_tooltip'),
		barChartLeftLabel: $t('activity_upgrade.6mo.bar_chart_left_label'),
		barChartRightLabel: $t('activity_upgrade.6mo.bar_chart_right_label'),
	}),
}
